import React from "react";
import {useStyles} from "../container/sidebar/styles";
import SideBar from '../container/sidebar/MySidebar';

const MainLayout = (props) => {

  const classes = useStyles();
  return (
    <div className={[classes.root, " sidebar-container "]}>
      <SideBar/>
      <div className={classes.content}>
        {props.children}
      </div>
    </div>
  );
};
export default MainLayout;
